(function () {
  if (window.__unifyJourney) return;
  window.__unifyJourney = true;
  // Load Shopify's permission API; do not assume permission while it is unavailable.
  if(window.Shopify&&!Shopify.customerPrivacy&&typeof Shopify.loadFeatures==='function'){
    Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(){});
  }
  var catalog = {};
  try { catalog = JSON.parse(document.getElementById('unify-journey-catalog').textContent); } catch (_) {}
  function allowed(){var privacy=window.Shopify&&Shopify.customerPrivacy;return !!(privacy&&typeof privacy.analyticsProcessingAllowed==='function'&&privacy.analyticsProcessingAllowed());}
  function publish(name, data) {
    if(!allowed())return false;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        var result = Shopify.analytics.publish(name, data);
        if (result && typeof result.catch === 'function') result.catch(function () {});
        return true;
      }
    } catch (_) {}
  }
  // Same-tab navigation can tear down the pixel before its queued hit is sent.
  // Consume a short-lived selection on the destination instead; never delay the link.
  try {
    var pending = JSON.parse(sessionStorage.getItem('unify-selection') || 'null');
    sessionStorage.removeItem('unify-selection');
    if (window.UNIFY_JOURNEY.pending(pending,location.pathname,Date.now())) {
      var attempts = 0;
      (function deliver() {
        if (!publish('unify:product_selected', pending.data) && ++attempts < 20) setTimeout(deliver, 100);
      })();
    }
  } catch (_) {}
  document.addEventListener('click' , function (event) {
    if (!allowed())return;
    if (event.button !== 0 || !event.target.closest || event.target.closest('button,input,select,textarea')) return;
    var link = event.target.closest('a[href]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    var match = url.pathname.match(/\/products\/([^/]+)\/?$/);
    var item = match && catalog[decodeURIComponent(match[1])];
    if (!item) return;
    var section = link.closest('[id^="shopify-section-"]') || link.closest('section[id]');
    var list = location.pathname + (section && section.id ? '#' + section.id : '');
    var data = {item_id: item.item_id, item_name: item.item_name, item_list_id: list.slice(0, 100)};
    if (!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && (!link.target || link.target === '_self')) {
      try {
        sessionStorage.setItem('unify-selection', JSON.stringify({path: url.pathname, time: Date.now(), data: data}));
        return;
      } catch (_) {}
    }
    publish('unify:product_selected', data);
  }, true);
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;
  var open = drawer.open, sequence = 0;
  new MutationObserver(function () {
    var next = drawer.open;
    if (next === open) return;
    open = next;
    var current = ++sequence;
    if (!open||!allowed()) return;
    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    fetch(root + 'cart.js', {headers: {Accept: 'application/json'}})
      .then(function (response) { if (!response.ok) throw new Error('cart unavailable'); return response.json(); })
      .then(function (cart) {
        if (!open || current !== sequence) return;
        var data=window.UNIFY_JOURNEY.cart(cart);
        if(data)publish('unify:cart_drawer_open',data);
      }).catch(function () {});
  }).observe(drawer, {attributes: true, attributeFilter: ['open']});
})();
